<template>
  <article class="page-header">
    <header class="page-header__hgroup">
      <h1 class="page-header__title">Ūma Yoga</h1>
      <p>A yoga studio I attended for many years in Quebec City. I helped them with their digital needs from 2019 until they closed in 2021 due to the COVID19 pandemic.</p>
    </header>

    <section class="layout-section__group">
      <div class="layout-section__hgroup">
        <h2 class="layout-section__heading">Mandate</h2>
      </div>

      <ul class="layout-section__list">
        <li>Establish a new brand image to better reflect their target audience</li>
        <li>Create a simple logo that represents the client’s values</li>
        <li>Design flyers to distribute throughout town</li>
        <li>Create social media design templates</li>
        <li>Design a new website</li>
        <li>Implement the new website as an SPA using VueJS and Sass</li>
        <li>Implement Eventbrite enrollment</li>
        <li>Connect the website frontend to Prismic CMS for editorial autonomy</li>
      </ul>
    </section>

    <section class="layout-section__group">
      <h2 class="layout-section__heading">Tools</h2>

      <ul class="layout-section__list">
        <li>Adobe XD, Photoshop, Illustrator</li>
        <li>HTML, SCSS, Vue JS</li>
        <li>Prismic (CMS)</li>
      </ul>
    </section>
  </article>
</template>

<script>
export default {
  name: 'UmaHeader'
}
</script>
